import React, { Component } from "react";
import { Select, MenuItem, FormControl, InputLabel } from '@material-ui/core';

import "./appointment-time-picker.css";

export default class AppointmentTimePicker extends Component {
    constructor() {
        super();

        this.timeslots = [ 
            { group: null, value: "AT", text: "Anytime" },
            { group: null, value: "AM", text: "Morning" },
            { group: null, value: "PM", text: "Afternoon" },
            { group: "AM", value: "08:00", text: "08:00" },
            { group: "AM", value: "08:30", text: "08:30" },
            { group: "AM", value: "09:00", text: "09:00" },
            { group: "AM", value: "09:30", text: "09:30" },
            { group: "AM", value: "10:00", text: "10:00" },
            { group: "AM", value: "10:30", text: "10:30" },
            { group: "AM", value: "11:00", text: "11:00" },
            { group: "AM", value: "11:30", text: "11:30" },
            { group: "PM", value: "12:00", text: "12:00" },
            { group: "PM", value: "12:30", text: "12:30" },
            { group: "PM", value: "13:00", text: "13:00" },
            { group: "PM", value: "13:30", text: "13:30" },
            { group: "PM", value: "14:00", text: "14:00" },
            { group: "PM", value: "14:30", text: "14:30" },
            { group: "PM", value: "15:00", text: "15:00" },
            { group: "PM", value: "15:30", text: "15:30" },
            { group: "PM", value: "16:00", text: "16:00" },
            { group: "PM", value: "16:30", text: "16:30" },
            { group: "PM", value: "17:00", text: "17:00" },
            { group: "PM", value: "17:30", text: "17:30" },
            { group: "PM", value: "18:00", text: "18:00" },
            { group: "PM", value: "18:30", text: "18:30" },
            { group: "PM", value: "19:00", text: "19:00" },
            { group: "PM", value: "19:30", text: "19:30" },
            { group: "PM", value: "20:00", text: "20:00" }
        ];

        this.state = { 
            value: "",
            timeslots: []
         };
    };

    componentDidMount = () => {

        let value = "";

        if (this.props.timeslot != null)
            value = this.props.timeslot;

        if (this.props.appointmentTime != null)
            value = this.props.appointmentTime;

        this.setState({ 
            timeslots: this.timeslots, 
            value: value 
        });
    };

    onChange = (event) => {

        const isSpecificTime = event.target.value.includes(":");

        this.props.onChange({
            event: event,
            timeslot: isSpecificTime 
                ? this.determineTimeslot(event.target.value)
                : event.target.value,
            appointmentTime: isSpecificTime 
                ? event.target.value 
                : null
        });

        this.setState({ value: event.target.value });
    };

    determineTimeslot = (value) => {
        const timeParts = value.split(":");

        if (Number(timeParts[0]) < 12) 
            return "AM";
        
        if (Number(timeParts[0]) >= 12) 
            return "PM";

        return "AT";
    }

    render() {
        return (<FormControl fullWidth>
                <InputLabel htmlFor={this.props.name}>{this.props.caption}</InputLabel>
                <Select 
                    onChange={this.onChange} 
                    name={this.props.name} 
                    value={this.state.value}
                    disabled={this.props.disabled}>
                    {this.state.timeslots.map((timeslot, index) => <MenuItem key={index} value={timeslot.value}>{timeslot.text}</MenuItem>)}
                </Select>
            </FormControl>);
    }
}